/*
 * @FilePath: /kitchen-offline-web/src/3DEngine/render/renderTypes/renderGroupMesh.js
 * @Author: Yongchao Wang
 * @Date: 2022-01-04 15:22:30
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-04-27 14:48:53
 * @Description:
 */
import { CornerCabinetDirection } from '../utils/enum';
import MeshManage from '../meshManage';
import VoxtorpDoor from '../specialHandler/voxtorpDoor';
import {
  // version2.0 无顶柜的时候默认抽油烟机距离顶柜的高度
  DEFAULTTOPHEIGHT, FRAMECATEGORY, FRAMEDEPTH, HANDLEPOSITION, TOPFRAME_GROUND, TOPPANELCONFIG,
  TYPECODE, VERSION_2_1, TOP_SPECIAL_LEATHER_HANDLE_ID, VERSION_2_2,
} from '../utils/kitchenConfig';
import {
  getCornerCabinetFrameXZ, checkFrameIsHighFrame,
} from '../utils/renderUtils';
import {
  getOldFaucetPosition, getOldSinkPosition, getNewFaucetPosition, getNewSinkPosition,
} from '../utils/renderSinkUtils';
import { getCornerCabinetDirection, getFramePositionInfo, separateRefrigeratorFrame } from '../utils/templatejsonUtils';

import CornerCabinetPlate from '../specialHandler/cornerCabinetPlate';
import RenderVersion from '../utils/renderVersion';
import HightFrame from '../specialHandler/highFrame';
import Refrigerator from '../specialHandler/refrigerator';

export default class RenderGroupMesh {
  constructor(templateJson, scene, engine, isbottom, camera) {
    this.engine = engine;
    this.canvasWidth = this.engine.getRenderingCanvasClientRect().width;
    this.canvasHeight = this.engine.getRenderingCanvasClientRect().height;

    this.templateJson = templateJson;
    this.camera = camera;
    this.scene = scene;
    // 踢脚板对象，方便改变颜色和大小
    this.skirtingBoard = [];
    this.skirtingBoardObjs = [];
    // 所有的mesh用于计算boundingbox，进而调整视角
    this.allMeshes = [];
    // 台面mesh
    this.topPanelMesh = [];
    this.topPanelObjs = [];
    this.sinkMesh = null;
    this.sinkFrameMesh = null;
    this.sinkFrameMeshLocation = 1;
    this.ventilatorMesh = null;
    this.highFrameMesh = null;
    this.highFrameMeshLocation = 1;
    this.isbottom = isbottom;
    this.rotationMeshes = {}; // 存旋转角度
    this.topLength1 = null;
    this.topLength2 = null;
    this.topLength3 = null;
    this.topLength4 = null;
    this.bottomLength1 = null;
    this.bottomLength2 = null;
    this.bottomLength3 = null;
    this.bottomLength4 = null;
    this.groundNode = null;
    this.roomMeshes = [];
    this.windowVisiable = true;
    this.calloutLineInfo = { bottom: {}, top: {} };
    this.XNeddHideMesh = []; // II型及U型柜隐藏l1的时候需要隐藏的mesh数组
    this.P2XNeddHideMesh = []; // II型及U型柜隐藏l3的时候需要隐藏的mesh数组
    this.commonNeedHideMesh = []; // II型及U型柜正常展示的时候需要隐藏的mesh数组
    this.XNeedShowMesh = []; // II型及U型柜隐藏l1的时候需要展示的mesh数组   踢脚板及台面都有三个模型控制显隐的
    this.P2XNeedShowMesh = []; // II型及U型柜隐藏l3的时候需要展示的mesh数组
    this.refrigeraror = null;
    this.copyTemplateJson = null;
    this.copyTemplateJson = JSON.parse(JSON.stringify(templateJson));
    this.isUSBottom = false; // 是否为U_S底柜  用来重写40柜深
    if (isbottom) {
      this.handleBottomFrames(templateJson.bottom);
    } else {
      this.handleTopFrames(templateJson.top);
    }
  }

  /**
   * @description: 处理底柜的逻辑，将底柜框架和门板组合起来，并形成一个mesh的Map暴露出来。
   * @param {*}
   * @return {*} 返回一个mesh的Map
   * @author: Yongchao Wang
   */
  handleBottomFrames(bottom) {
    if (!bottom) { return; }
    if (bottom.type === 'U_S') { this.isUSBottom = true; }

    const { frames, refrigeratorLength, refrigeratorFrame } = separateRefrigeratorFrame(bottom);

    frames.forEach((frame, index) => {
      frame.forEach((el) => {
        const element = el;
        element.componentBasic.longEdge = element.longEdge;
        element.componentBasic.edge = `length${index + 1}`;
        element.componentBasic.categoryId = element.categoryId;

        if (element.sink) {
          this.groupMeshsFrameSink(element.componentBasic, element.sink);
          this.sinkFrameMeshLocation = index + 1;
        }
        if (element.stove) {
          this.groupMeshsFrameStove(element.componentBasic, element.stove);
        }
        if (checkFrameIsHighFrame(element)) {
          // 一期顶柜空高柜
          if (HightFrame.checkEmptyPlaceholderHighFrame(element)) {
            return;
          }
          this.highFrameMeshLocation = index + 1;
          // 版本兼容 2.1版本门板顺序调整了，小于2.1的走原渲染方式
          if (RenderVersion.checkOldRenderVersion(this?.templateJson?.version, VERSION_2_1)) {
            const renderVersion = new RenderVersion(this);
            renderVersion.oldFunGroupMeshsHighFrameDoors(element, element.doors, 'bottom');
          } else {
            this.groupMeshsHighFrameDoors(element, element.doors, 'bottom');
          }
        } else {
          this.groupMeshsFrameDoors(element.componentBasic, element.doors, true, element);
        }
      });
    });

    if (refrigeratorFrame) {
      this.refrigeraror = new Refrigerator(
        this.templateJson, refrigeratorFrame, refrigeratorLength, 'bottom', this.scene,
      );
    }
  }

  /**
   * @description: 处理顶柜的逻辑，将底柜框架和门板组合起来，并形成一个mesh的Map暴露出来。
   * @param {*}
   * @return {*} 返回一个mesh的Map
   * @author: Yongchao Wang
   */
  handleTopFrames(top) {
    if (!top) {
      return;
    }

    const { frames, refrigeratorLength, refrigeratorFrame } = separateRefrigeratorFrame(top);

    frames.forEach((frame, index) => {
      frame.forEach((el) => {
        const element = el;
        element.componentBasic.longEdge = element.longEdge;
        element.componentBasic.categoryId = element.categoryId;
        if (checkFrameIsHighFrame(element)) {
          // 一期顶柜空高柜
          if (HightFrame.checkEmptyPlaceholderHighFrame(element)) {
            return;
          }
          this.highFrameMeshLocation = index + 1;
          // 版本兼容 2.1版本门板顺序调整了，小于2.1的走原渲染方式
          if (RenderVersion.checkOldRenderVersion(this?.templateJson?.version, VERSION_2_1)) {
            const renderVersion = new RenderVersion(this);
            renderVersion.oldFunGroupMeshsHighFrameDoors(element, element.doors, 'top');
          } else {
            this.groupMeshsHighFrameDoors(element, element.doors, 'top');
          }
        } else {
          this.groupMeshsFrameDoors(element.componentBasic, element.doors, false);
        }
        // if (!checkFrameIsHighFrame(element)) {
        //   this.groupMeshsFrameDoors(element.componentBasic, element.doors, false);
        // }
      });
    });
    if (refrigeratorFrame) {
      this.refrigeraror = new Refrigerator(
        this.templateJson, refrigeratorFrame, refrigeratorLength, 'top', this.scene,
      );
    }
  }

  /**
   * @description: 将柜子和柜门组合起来
   * @param {*} frame 柜子框架
   * @param {*} doors 柜门
   * @param {*} isbottom 是否底柜
   * @param {*} frameAllInfo 整个柜子的对象
   * @return {*}
   * @author: Yongchao Wang
   */
  groupMeshsFrameDoors(frame, doors, isbottom, frameAllInfo) {
    const parent = new MeshManage(this.scene.getMeshByName(frame.id));
    this.addMesh(parent.mesh);
    let tempDoors = doors;
    if (!(doors instanceof Array)) {
      tempDoors = [doors];
    }
    tempDoors = tempDoors.filter((e) => e.componentBasic.show && e.componentBasic.modelUrl);
    const children = tempDoors.map((e, index) => {
      const child = new MeshManage(this.scene.getMeshByName(e.componentBasic.id));

      this.addMesh(child.mesh);
      // template version2.0 如果是顶柜并且沃拓普 旋转顶柜柜门 在添加到父级之前旋转
      if (!isbottom && VoxtorpDoor.isVoxtorpDoor(this.templateJson.top)) {
        const voxtorpDoor = new VoxtorpDoor(frame, e, child, this.scene);
        voxtorpDoor.rotateTopDoor();
      }
      parent.addChildModel(child);
      // 把手
      if (e.handle) {
        this.groupMeshsDoorHandle(frame, e, child, isbottom);
      }
      // 和后端align好，门板顺序是从左到右，抽屉是从下到上
      if (TYPECODE.DOORPLANK(e.componentBasic.typeCode)) {
        // 如果不止一扇门板,第二扇门板开始贴在第一扇门板右边
        if (index > 0) {
          const preChild = new MeshManage(this.scene.getMeshByName(doors[index - 1].componentBasic.id));
          child.setModelPosition(
            {
              x: preChild.getModelSize().x + preChild.mesh.position.x,
              y: child.mesh.position.y,
              z: parent.getModelSize().z * 0.5 + child.getModelSize().z * 0.5,
            },
          );
        } else {
          const count = tempDoors.length - 1;
          child.setModelPosition(
            {
              x: child.mesh.position.x - child.getModelSize().x * 0.5 * count,
              y: child.mesh.position.y,
              z: parent.getModelSize().z * 0.5 + child.getModelSize().z * 0.5,
            },
          );
        }
      } else if (TYPECODE.DRAWER(e.componentBasic.typeCode)) {
        // 如果不止一个抽屉,第二扇抽屉开始贴在第一抽屉板上面
        if (index > 0) {
          const preChild = new MeshManage(this.scene.getMeshByName(doors[index - 1].componentBasic.id));

          child.setModelPosition(
            {
              x: child.mesh.position.x,
              y: preChild.mesh.position.y + preChild.getModelSize().y,
              z: parent.getModelSize().z * 0.5 + child.getModelSize().z * 0.5,
            },
          );
        } else {
          child.setModelPosition(
            {
              x: child.mesh.position.x,
              y: child.mesh.position.y,
              z: parent.getModelSize().z * 0.5 + child.getModelSize().z * 0.5,
            },
          );
        }
      }
      // 转角柜
      if ([FRAMECATEGORY.CATEGORY_8, FRAMECATEGORY.CATEGORY_27, FRAMECATEGORY.CATEGORY_28].includes(frame.categoryId)) {
        let commonCornetPlate; // 正常的门板模型
        let rotationCornetPlate; // 旋转的补板模型

        switch (frame.width) {
          case 880:
            child.setModelPosition(
              {
                x: -parent.getModelSize().x * 0.5 + child.getModelSize().x * 0.5,
                y: child.mesh.position.y,
                z: parent.getModelSize().z * 0.5 - child.getModelSize().z * 0.5,
              },
            );
            break;

          default:
            // 判断是否有两个  如果没有就不渲染  要不会报错
            if (frameAllInfo?.sealPlate?.length === 2) {
              commonCornetPlate = new CornerCabinetPlate(this.scene.getMeshByName(frameAllInfo.sealPlate[0].id));
              rotationCornetPlate = new CornerCabinetPlate(this.scene.getMeshByName(frameAllInfo.sealPlate[1].id));
              this.addMesh(commonCornetPlate.mesh);
              this.addMesh(rotationCornetPlate.mesh);
              parent.addChildModel(commonCornetPlate);
              parent.addChildModel(rotationCornetPlate);
              commonCornetPlate.setCornerCabinetPlateScale(parent, child, false);
              rotationCornetPlate.setCornerCabinetPlateScale(parent, child, true);
            }
            if (frame.longEdge === 1 || (frame.longEdge === 2 && frame.edge === 'length2')) {
              // 1280*680右开门转角柜 柜子在L1上
              // 1280*680右开门转角柜 柜子在L2上
              // 判断是否有两个  如果没有就不渲染  要不会报错
              if (frameAllInfo?.sealPlate?.length === 2) {
                // 0, Math.PI / 2, 0
                commonCornetPlate.setCornerCabinetPlatePosition(parent, false, 'right', child);
                rotationCornetPlate.setCornerCabinetPlatePosition(parent, true, 'right', child);
                if (frame.longEdge === 1) {
                  this.addRotationMeshes(
                    { id: frameAllInfo.sealPlate[1].id, rotation: { x: 0, y: Math.PI / 2, z: 0 } },
                  );
                } else {
                  this.addRotationMeshes(
                    { id: frameAllInfo.sealPlate[0].id, rotation: { x: 0, y: Math.PI / 2, z: 0 } },
                  );
                }
              }
              child.setModelPosition(
                {
                  x: parent.getModelSize().x * 0.5 - child.getModelSize().x * 0.5,
                  y: 0,
                  z: parent.getModelSize().z * 0.5 + child.getModelSize().z * 0.5
                     - (parent.getModelSize().z - FRAMEDEPTH.BOTTOM),
                },
              );
            } else {
              // 1280*680左开门转角柜 柜子在L2上
              // 1280*680左开门转角柜 柜子在L1上
              // 判断是否有两个  如果没有就不渲染  要不会报错
              if (frameAllInfo?.sealPlate?.length === 2) {
                commonCornetPlate.setCornerCabinetPlatePosition(parent, false, 'left', child);
                rotationCornetPlate.setCornerCabinetPlatePosition(parent, true, 'left', child);
                if (frame.longEdge === 2) {
                  this.addRotationMeshes(
                    { id: frameAllInfo.sealPlate[0].id, rotation: { x: 0, y: Math.PI / 2, z: 0 } },
                  );
                } else {
                  this.addRotationMeshes(
                    { id: frameAllInfo.sealPlate[1].id, rotation: { x: 0, y: Math.PI / 2, z: 0 } },
                  );
                }
              }
              child.setModelPosition(
                {
                  x: -parent.getModelSize().x * 0.5 + child.getModelSize().x * 0.5,
                  y: 0,
                  z: parent.getModelSize().z * 0.5 + child.getModelSize().z * 0.5
                     - (parent.getModelSize().z - FRAMEDEPTH.BOTTOM),
                },
              );
            }

            break;
        }
      } else if ((frame.categoryId === FRAMECATEGORY.CATEGORY_9)) {
        const rotation = child.addRotation(0, Math.PI / 4, 0);
        this.rotationMeshes[e.componentBasic.id] = rotation;
        child.setModelPosition({ x: 0.19, y: child.mesh.position.y, z: 0.19 });// 转角柜情况特殊z轴固定值
      }
      return child;
    });
    return { parent, children };
  }

  addRotationMeshes({ id, rotation }) {
    this.rotationMeshes[id] = rotation;
  }

  /**
     * @description: 将高柜柜子和柜门组合起来
     * @param {*} frame 高柜
     * @param {*} doors 柜门
     * @param {*} location 顶柜还是底柜
     * @return {*}
     * @author: Yongchao Wang
     */
  groupMeshsHighFrameDoors(frameComponent, doors, location) {
    const frame = frameComponent.componentBasic;
    const { categoryId } = frameComponent;
    const parent = new MeshManage(this.scene.getMeshByName(frame.id));
    this.addMesh(parent.mesh);
    this.highFrameMesh = parent.mesh;
    let tempDoors = doors;
    let preHighDoorRotation = { x: 0, y: 0, z: 0 }; // 上一个高柜柜门的旋转角度，旋转后会上移，会影响下一个门板的排列
    let preMeshManage;
    // 如果是高柜/全隔板3开门，门板顺序倒一下，后端给的顺序不对
    // if (
    //   frameComponent.categoryId === FRAMECATEGORY.CATEGORY_10
    //   || frameComponent.categoryId === FRAMECATEGORY.CATEGORY_33
    //   || frameComponent.categoryId === FRAMECATEGORY.CATEGORY_34
    //   || frameComponent.categoryId === FRAMECATEGORY.CATEGORY_35
    //   || frameComponent.categoryId === FRAMECATEGORY.CATEGORY_36
    //   || frameComponent.categoryId === FRAMECATEGORY.CATEGORY_37
    // ) {
    // debugger;
    tempDoors = [...tempDoors].reverse();
    // }
    if (!(doors instanceof Array)) {
      tempDoors = [doors];
    }
    tempDoors = tempDoors.filter((e) => e.componentBasic.show && e.componentBasic.modelUrl);
    const children = tempDoors.map((e, index) => {
      // 因为上面倒序门板顺序
      let isbottom = false;// 是否是底部把手，高柜的上部柜子需要将把手装下面
      switch (categoryId) {
        case FRAMECATEGORY.CATEGORY_10:
        case FRAMECATEGORY.CATEGORY_33:
        case FRAMECATEGORY.CATEGORY_35:
        case FRAMECATEGORY.CATEGORY_36:
          // 高柜/全隔板3开门 index 0-》1 上柜-》下柜，决定了把手位置
          isbottom = index === 0;
          // if (index === 0) {
          //   isbottom = true;
          // } else {
          //   isbottom = false;
          // }
          break;
        case FRAMECATEGORY.CATEGORY_11:
          // 高柜/烤箱柜 (一个洞) 三抽屉面板 -》上门板
          isbottom = index < 3;
          // if (index < 3) {
          //   isbottom = true;
          // } else {
          //   isbottom = false;
          // }
          break;

        default:
          // FRAMECATEGORY.CATEGORY_12 FRAMECATEGORY.CATEGORY_34 FRAMECATEGORY.CATEGORY_37
          // 高柜/微波炉和烤箱柜(两个洞) 两抽屉面板 -》 上门板
          isbottom = index < 2;
          // if (index < 2) {
          //   isbottom = true;
          // } else {
          //   isbottom = false;
          // }
          break;
      }
      const child = new MeshManage(this.scene.getMeshByName(e.componentBasic.id));
      this.addMesh(child.mesh);

      parent.addChildModel(child);
      // 把手
      if (e.handle) {
        this.groupMeshsDoorHandle(frame, e, child, isbottom, true);
      }
      // 和后端align好，门板顺序是从左到右，抽屉是从下到上
      if (TYPECODE.DOORPLANK(e.componentBasic.typeCode)) {
        this.handleHighFrameDoorPlanks(parent, child, tempDoors, categoryId, index);
      } else if (TYPECODE.DRAWER(e.componentBasic.typeCode)) {
        // 如果不止一个抽屉,第二扇抽屉开始贴在第一抽屉板上面
        if (index > 0) {
          const preChild = new MeshManage(this.scene.getMeshByName(tempDoors[index - 1].componentBasic.id));
          // 抽屉个数 对于CATEGORY_11 3个  对于CATEGORY_12 2个
          const doorPlankCount = (categoryId === FRAMECATEGORY.CATEGORY_11) ? 3 : 2;
          // 门板按顺序后 对于CATEGORY_11 CATEGORY_12 以外的柜体不需要移动
          const moveY = (
            (categoryId === FRAMECATEGORY.CATEGORY_11 || categoryId === FRAMECATEGORY.CATEGORY_12)
              && (VoxtorpDoor.isVoxtorpDoor(this.templateJson.bottom)
                  || VoxtorpDoor.isVoxtorpDoor(this.templateJson.top)) && index > doorPlankCount - 1)
            ? 0 : preChild.getModelSize().y;
          child.setModelPosition(
            {
              x: child.mesh.position.x,
              y: preChild.mesh.position.y + moveY,
              z: parent.getModelSize().z * 0.5 + child.getModelSize().z * 0.5,
            },
          );
        } else {
          child.setModelPosition(
            {
              x: child.mesh.position.x,
              y: child.mesh.position.y,
              z: parent.getModelSize().z * 0.5 + child.getModelSize().z * 0.5,
            },
          );
        }
      }
      // template version2.0 如果是顶柜并且沃拓普 处理高柜的柜门  在添加到父级之前旋转
      // TODO: version 2.0 目前是看底柜的是不是沃拓普系列，因为暂时高柜不会和顶柜关联。
      if (location === 'bottom' && VoxtorpDoor.isVoxtorpDoor(this.templateJson.bottom)) {
        const voxtorpDoor = new VoxtorpDoor(frameComponent, e, child, this.scene);
        preHighDoorRotation = voxtorpDoor.rotateHighFrameDoor(index, preHighDoorRotation, preMeshManage);
        preMeshManage = child;
      } else if (location === 'top' && VoxtorpDoor.isVoxtorpDoor(this.templateJson.top)) {
        const voxtorpDoor = new VoxtorpDoor(frameComponent, e, child, this.scene);
        preHighDoorRotation = voxtorpDoor.rotateHighFrameDoor(index, preHighDoorRotation, preMeshManage);
        preMeshManage = child;
      } else {
        preMeshManage = null;
        preHighDoorRotation = { x: 0, y: 0, z: 0 };
      }
      return child;
    });
    return { parent, children };
  }

  /**
     * @description: 单独处理高柜的门板
     * @param {*} parent 父mesh
     * @param {*} child 子mesh
     * @param {*} doors 门板数组
     * @param {*} categoryId 类别id
     * @param {*} index 索引
     * @return {*}
     * @author: Yongchao Wang
     */
  handleHighFrameDoorPlanks(parent, child, doors, categoryId, index) {
    switch (categoryId) {
      case FRAMECATEGORY.CATEGORY_10:
      case FRAMECATEGORY.CATEGORY_33:
      case FRAMECATEGORY.CATEGORY_34:
      case FRAMECATEGORY.CATEGORY_35:
      case FRAMECATEGORY.CATEGORY_36:
      case FRAMECATEGORY.CATEGORY_37:
        if (index > 0) {
          const preChild = new MeshManage(this.scene.getMeshByName(doors[index - 1].componentBasic.id));
          child.setModelPosition(
            {
              x: child.mesh.position.x,
              y: child.mesh.position.y + preChild.mesh.position.y + preChild.getModelSize().y,
              z: parent.getModelSize().z * 0.5 + child.getModelSize().z * 0.5,
            },
          );
        } else {
          child.setModelPosition(
            {
              x: child.mesh.position.x,
              y: child.mesh.position.y,
              z: parent.getModelSize().z * 0.5 + child.getModelSize().z * 0.5,
            },
          );
        }
        break;
      case FRAMECATEGORY.CATEGORY_11: case FRAMECATEGORY.CATEGORY_12:
        child.setModelPosition(
          {
            x: child.mesh.position.x,
            y: parent.getModelSize().y - child.getModelSize().y,
            z: parent.getModelSize().z * 0.5 + child.getModelSize().z * 0.5,
          },
        );

        break;
      default:

        break;
    }
  }

  /**
     * @description: 将水槽和水槽柜、水龙头组合起来，并将水槽设置到合理位置
     * @param {*} frame 柜子
     * @param {*} sink 水槽
     * @return {*}
     * @author: Yongchao Wang
     */
  groupMeshsFrameSink(frame, sink) {
    const parent = new MeshManage(this.scene.getMeshByName(frame.id));
    this.addMesh(parent.mesh);
    this.sinkMesh = this.scene.getMeshByName(sink.componentBasic.id);
    this.sinkFrameMesh = this.scene.getMeshByName(frame.id);
    const child = new MeshManage(this.scene.getMeshByName(sink.componentBasic.id));
    parent.addChildModel(child);

    if (RenderVersion.checkOldRenderVersion(this?.templateJson?.version, VERSION_2_2)) {
      child.setModelPosition(getOldSinkPosition(frame, parent, child, frame.categoryId === FRAMECATEGORY.CATEGORY_27));
    } else {
      child.setModelPosition(
        getNewSinkPosition(frame, parent, child, sink.hasHole, frame.categoryId === FRAMECATEGORY.CATEGORY_27),
      );
    }

    this.addMesh(child.mesh);
    // 某些情况没有水龙头
    if (sink?.faucet?.componentBasic?.id) {
      const grandChild = new MeshManage(this.scene.getMeshByName(sink.faucet.componentBasic.id));
      parent.addChildModel(grandChild);
      if (RenderVersion.checkOldRenderVersion(this?.templateJson?.version, VERSION_2_2)) {
        grandChild.setModelPosition(getOldFaucetPosition(parent,
          child, grandChild, frame.categoryId === FRAMECATEGORY.CATEGORY_27));
      } else {
        grandChild.setModelPosition(
          getNewFaucetPosition(frame, parent,
            child, grandChild, sink.hasHole, frame.categoryId === FRAMECATEGORY.CATEGORY_27, sink?.faucet),
        );
      }
      this.addMesh(grandChild.mesh);
    }

    return { parent, child };
  }

  /**
     * @description: 将燃气灶和柜子组合起来
     * @param {*} frame 柜子
     * @param {*} stove 燃气灶
     * @return {*}
     * @author: Yongchao Wang
     */
  groupMeshsFrameStove(frame, stove) {
    const parent = new MeshManage(this.scene.getMeshByName(frame.id));
    this.addMesh(parent.mesh);
    const child = new MeshManage(this.scene.getMeshByName(stove.componentBasic.id));
    parent.addChildModel(child);
    const { longEdge, edge } = frame;
    const cornerCabinetDirection = getCornerCabinetDirection(longEdge, parseInt(edge.charAt(edge.length - 1), 10));
    let y = parent.getModelSize().y + TOPPANELCONFIG.HEIGHT;
    // 当宽度为600或者1280转角柜的时候 这个时候使用的是电磁炉需要跟台面齐平
    // 但是目前没有挖洞所以留0.005的不穿模安全距离
    if (frame.width === 600 || frame.width === 1280) {
      y = parent.getModelSize().y + TOPPANELCONFIG.HEIGHT - child.getModelSize().y + 0.005;
    }
    // 判断灶台是否在转角柜上面
    if (frame.categoryId === FRAMECATEGORY.CATEGORY_28) {
      const parentPosition = parent.mesh.position;
      const parentSize = parent.getModelSize();
      const childSize = child.getModelSize();
      // 在转角柜上面的时候的处理方法跟水槽一样 见上面groupMeshsFrameSink方法
      if (cornerCabinetDirection === CornerCabinetDirection.Right) {
        child.setModelPosition({ y, ...getCornerCabinetFrameXZ(parentPosition, parentSize, childSize, 'right') });
      } else {
        child.setModelPosition({ y, ...getCornerCabinetFrameXZ(parentPosition, parentSize, childSize, 'left') });
      }
    } else {
      child.setModelPosition({ x: child.mesh.position.x, y, z: child.mesh.position.z });
    }

    this.addMesh(child.mesh);
    return { parent, child };
  }

  /**
     * @description: 渲染油烟机和调整油烟机的顶柜
     * @param {*} element 整个frame对象
     * @return {*}
     * @author: Yongchao Wang
     */
  renderVentilator(element, rotation) {
    // 吸油烟机的渲染需要贴墙
    const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
    const ventilatorMeshManage = new MeshManage(this.scene.getMeshByName(element.ventilator.componentBasic.id));

    this.ventilatorMesh = ventilatorMeshManage.mesh;
    const { position } = meshManage.mesh;
    let ventilatorFrameEdgeLongDistance; // 灶下柜在排列方向上的边缘距离原点的长度
    let ventilatorFrameEdgeShortDistance; // 离得近一些的距离
    let ventilatorEdge;
    // 是L2边上
    switch (rotation.y) {
      case -Math.PI / 2:
        ventilatorFrameEdgeLongDistance = position.z + meshManage.getModelSize().z / 2;
        ventilatorFrameEdgeShortDistance = position.z - meshManage.getModelSize().z / 2;
        ventilatorEdge = 'length2';
        break;
      case 0:
        ventilatorFrameEdgeLongDistance = -position.x + meshManage.getModelSize().x / 2;
        ventilatorFrameEdgeShortDistance = -position.x - meshManage.getModelSize().x / 2;
        ventilatorEdge = 'length1';
        break;
      case -Math.PI:
        ventilatorFrameEdgeLongDistance = -position.x + meshManage.getModelSize().x / 2;
        ventilatorFrameEdgeShortDistance = -position.x - meshManage.getModelSize().x / 2;
        ventilatorEdge = 'length3';
        break;
      default:
        break;
    }
    this.addMesh(this.ventilatorMesh);
    ventilatorMeshManage.addRotation(rotation.x, rotation.y, rotation.z);
    this.rotationMeshes[element.componentBasic.id] = rotation;
    // 记录油烟机在哪条边和距离，摆好顶柜后调整
    this.ventilatorFrameEdgeLongDistance = ventilatorFrameEdgeLongDistance;
    this.ventilatorFrameEdgeShortDistance = ventilatorFrameEdgeShortDistance;
    this.ventilatorEdge = ventilatorEdge;
    const topToground = TOPFRAME_GROUND(this.templateJson);

    // const stoveMesh = new MeshManage(this.scene.getMeshByName(element.stove.componentBasic.id));
    let ventilatorPosition = {
      y: this.templateJson?.top
        ? topToground - this.templateJson?.top?.height * 0.01 - 0.15 : topToground - DEFAULTTOPHEIGHT - 0.15,
    };
    if (element.categoryId === FRAMECATEGORY.CATEGORY_28) {
      // 判断转角柜是左转角还是右转角
      const { cornerCabinetDirection } = getFramePositionInfo(this.templateJson, 'ventilator');
      const parentPosition = meshManage.mesh.position;
      const parentSize = meshManage.getModelSize();
      const childSize = ventilatorMeshManage.getModelSize();
      // 在转角柜上面的时候的处理方法跟水槽一样 见上面groupMeshsFrameSink方法
      if (cornerCabinetDirection === CornerCabinetDirection.Right) {
        ventilatorPosition = {
          ...ventilatorPosition,
          ...getCornerCabinetFrameXZ(parentPosition, parentSize, childSize, 'right', ventilatorEdge, 'ventilator'),
        };
      } else {
        ventilatorPosition = {
          ...ventilatorPosition,
          ...getCornerCabinetFrameXZ(parentPosition, parentSize, childSize, 'left', ventilatorEdge, 'ventilator'),
        };
      }
    } else {
      let commonx;
      let commonz;
      switch (ventilatorEdge) {
        case 'length1':
          commonx = position.x;
          commonz = ventilatorMeshManage.getModelSize().z / 2;
          break;
        case 'length2':
          commonx = -ventilatorMeshManage.getModelSize().z / 2;
          commonz = position.z;
          break;
        default:
          commonx = position.x;
          commonz = position.z + meshManage.getModelSize().z / 2 - ventilatorMeshManage.getModelSize().z / 2;
          break;
      }
      ventilatorPosition = {
        x: commonx,
        y: this.templateJson?.top
          ? topToground - this.templateJson?.top?.height * 0.01 - 0.15 : topToground - DEFAULTTOPHEIGHT - 0.15,
        z: commonz,
      };
    }
    // 判断燃气灶是否在转角柜上面如果在转角柜上面话的 需要特殊处理
    ventilatorMeshManage.setModelPosition(ventilatorPosition);
  }

  /**
     * @description: 组合门板和把手
     * @param {*} frame 柜子信息
     * @param {*} e 门板信息
     * @param {*} child 门板对象
     * @param {*} isbottom 是否是底柜
     * @param {*} isHighFrame 是否是高柜
     * @return {*}
     * @author: Yongchao Wang
     */
  groupMeshsDoorHandle(frame, e, child, isbottom, isHighFrame = false) {
    const grandChild = new MeshManage(this.scene.getMeshByName(e.handle.componentBasic.id));

    // 88的底柜 把手特殊处理
    if (frame.categoryId === FRAMECATEGORY.CATEGORY_8 && frame.width === 880) {
      const rotation = grandChild.addRotation(0, Math.PI, -Math.PI / 2);
      this.rotationMeshes[e.handle.componentBasic.id] = rotation;
      grandChild.setModelPosition({
        x: -child.getModelSize().x / 2 + 0.02,
        y: child.getModelSize().y - HANDLEPOSITION.FRAMEBOTTOMTOTOP - grandChild.getModelSize().y,
        z: 0,
      });
      if (grandChild.getModelSize().z > child.getModelSize().x) {
        this.rotationMeshes[e.handle.componentBasic.id] = grandChild.addRotation(0, Math.PI / 2, 0);
        grandChild.setModelPosition({
          x: -child.getModelSize().x / 2 + HANDLEPOSITION.FRAMEBOTTOMTOTOP,
          y: child.getModelSize().y - HANDLEPOSITION.FRAMEBOTTOMTOTOP - grandChild.getModelSize().z / 2,
          z: child.getModelSize().z / 2,
        });
      }
    } else {
      let rotation;
      // 顶柜皮把手特殊处理
      rotation = e?.handle?.componentBasic?.componentId === TOP_SPECIAL_LEATHER_HANDLE_ID
        ? grandChild.addRotation(Math.PI * 1.5, Math.PI / 2, -Math.PI / 2)
        : grandChild.addRotation(0, Math.PI / 2, -Math.PI / 2);

      // 把手特例调整   如果宽度大于柜子就竖着装   小于柜子的话不变
      if (grandChild.getModelSize().z > child.getModelSize().x) {
        rotation = grandChild.addRotation(0, Math.PI / 2, 0);
      }

      this.rotationMeshes[e.handle.componentBasic.id] = rotation;

      // 和后端align好，门板顺序是从左到右，抽屉是从下到上
      if (TYPECODE.DOORPLANK(e.componentBasic.typeCode) && grandChild) {
        // 如果存在把手
        // 如果是底柜
        if (isbottom && grandChild.getModelSize().z > child.getModelSize().x) {
          // 把手特例调整  把手过长装在柜子的右上角 并竖着装
          grandChild.setModelPosition({
            x: -child.getModelSize().x / 2 + HANDLEPOSITION.FRAMEBOTTOMTOTOP,
            y: child.getModelSize().y - HANDLEPOSITION.FRAMEBOTTOMTOTOP - grandChild.getModelSize().z / 2,
            z: child.getModelSize().z / 2,
          });
        } else if (isbottom) {
          grandChild.setModelPosition({
            x: 0,
            y: child.getModelSize().y - HANDLEPOSITION.FRAMEBOTTOMTOTOP - grandChild.getModelSize().y,
            z: child.getModelSize().z / 2,
          });
        } else if (isHighFrame) {
          // 如果是高柜上柜把手依然居中
          grandChild.setModelPosition({
            x: 0,
            y: HANDLEPOSITION.FRAMETOPTOBOTTOM,
            z: child.getModelSize().z / 2,
          });
        } else {
          grandChild.setModelPosition({
            x: child.getModelSize().x / 2 - HANDLEPOSITION.FRAMETOPTOLEFT - grandChild.getModelSize().x / 2,
            y: HANDLEPOSITION.FRAMETOPTOBOTTOM,
            z: child.getModelSize().z / 2,
          });
        }
      } else if (TYPECODE.DRAWER(e.componentBasic.typeCode) && isbottom && grandChild) {
        grandChild.setModelPosition({
          x: 0,
          y: child.getModelSize().y - grandChild.getModelSize().y / 2 - HANDLEPOSITION.DRAWERTOTOP,
          z: child.getModelSize().z / 2,
        });
      }
    }
    child.addChildModel(grandChild);
  }
}
